import { InlineAlertType, InlineAlertWidget } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { openReactActionDialog } from '~src/commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { L10n } from '~src/commonInfra/L10n/L10n';
import { HelpService } from '~src/commonInfra/services/HelpService';
import { ToasterService,ToastType } from '~src/commonInfra/services/ToasterService';
import { SettingsStyles } from '~src/settings/styles/CommonStyles';

import { IShareClusterToTenantSitesResult } from '../../serverApi/requests/ShareClusterToTenantSites';
import { BaasEdgePoolAndCluster } from '../../serverApi/resources/BaasEdgePoolAndCluster';
import { ActionItemInfo } from '../MoreActionsMenu';
import { getGeneralErrorMessage } from '../utils/EdgePoolErrorUtilities';

export type ShareClusterDialogProps = Readonly<{
  clusterName: string;
}>

export function openShareClusterDialog(actionItem: ActionItemInfo) {
  const {clusterId, clusterName } = actionItem;

  const dialogInstance = openReactActionDialog({
      title: Messages.dataConnectSiteSettingsShareClusterTitle(),
      bodyComponent: ShareClusterDialogBody,
      initialBodyProps: {clusterName: clusterName},
      initialDialogState: { hasError: false },
      actionName: Messages.dataConnectSiteSettingsShareClusterSave(),
      action: () => {
          return  BaasEdgePoolAndCluster.shareClusterToTenantSites({clusterId: clusterId})
          .then((result: IShareClusterToTenantSitesResult) => {
            actionItem.refreshPoolsAndClusters();
            if (result.success) {
              ToasterService.instance.pop({ type: ToastType.Success, text: Messages.dataConnectSiteSettingsShareClusterSuccess({ CLUSTER_NAME: L10n.elideIfLong(clusterName) }) });
            }
            if (result.errors) {
              ToasterService.instance.pop({
                type: ToastType.Error,
                text: getGeneralErrorMessage(result.errors[0].code, result.errors[0].message),
                actionMessage: Messages.dataConnectSiteSettingsLearnMore(),
                actionHref: HelpService.getServerHelpUrlByCategory('DataConnect-ClustersAndNodes')
              });
            }
            return Promise.resolve();
          });
      },
      dismissDialogOnActionFailed: true,
      dialogWidth: TabDialogWidth.width375px,
      showCloseButton: true
  });
  return Promise.resolve(dialogInstance.result);
}


export function ShareClusterDialogBody(props: ShareClusterDialogProps) {

  const descriptionDivClassName = `${SettingsStyles.settingsGroupDescription}`;

  return (
    <div>
      <div className={descriptionDivClassName} data-tb-test-id={'share-cluster-dialog-body'}>
        <span className={descriptionLineClass} style={{marginTop: 0}}>
          {Messages.dataConnectSiteSettingsShareClusterDescription({CLUSTER_NAME: props.clusterName})}
        </span>
        <div>
          <InlineAlertWidget
              children={
                <span>{Messages.dataConnectSiteSettingsShareClusterWarning()}</span>
              }
              type={InlineAlertType.Warning}
              testId={'share-cluster-dialog-body-alert'}/>
        </div>
      </div>
    </div>
  );
}
const descriptionLineClass = style({ marginTop: 8, display: 'block' });

